import React from 'react'
import PropTypes from 'prop-types'
import Circle from '../../common/Circle'
import Icon from '../../common/Icon'
import Text from '../../common/Text'
import Spacer from '../../common/Spacer'
import { theme } from '../../../style'

const CIRCLE_SIZE = 50

const TreesCounter = ({
    trees,
    big,
    ...rest
}) => (
    <Circle
        radius={CIRCLE_SIZE + (big ? 10 : 0)}
        borderColor={theme.lightBlue1}
        alignItems="center"
        justifyContent="center"
        bgColor="white"
        {...rest}
    >
        <Icon
            iconName="treeGreen@2x.png"
            alt="tree"
            height={20}
            width={22}
            alignSelf="center"
        />
        <Spacer size="XXXXS" />
        <Text
            size="M"
            color="lightGreen"
        >
            {trees}
        </Text>
    </Circle>
)

TreesCounter.propTypes = {
    big: PropTypes.bool,
    trees: PropTypes.number.isRequired,
}

TreesCounter.defaultProps = {
    big: false,
}

export default TreesCounter
